var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container"},[_c('section',{staticClass:"mt-4 mb-10"},[_c('h1',{staticClass:"font-size--24",staticStyle:{"word-break":"keep-all"}},[_vm._v(" 비상금 실행을 위해 필요한 자료들을 체크하고 있습니다."),_c('br')]),_c('h3',{staticClass:"font-size--18 mt-10",staticStyle:{"word-break":"keep-all"}},[_vm._v(" * 카드사 변경까지 모두 끝난 경우에만 모집이 시작됩니다. "),_c('br')])])])
}]

export { render, staticRenderFns }